import API from 'services/api';

import { ICalculationUpdate } from '../models';

interface IProps {
  calculationId: string;
  payload: ICalculationUpdate;
}

export const updateCalculation = ({ calculationId, payload }: IProps): Promise<any> =>
  API.put(`api/accommodation/calculations/${calculationId}`, payload).then(
    response => response?.data,
  );
